import { useSelector } from 'react-redux';
import useSessionUser from '../../../hooks/useSessionUser';
import { FolderMessageContent, Message } from '../../../models/communication.types';
import { RootState } from '../../../store';
import { TableMessageParticipant } from './MessagesList.types';
import { getParticipantDisplayName, getTableParticipant } from './utils';

interface MessageParticipantCellProps {
  message: Message | FolderMessageContent;
  revert?: boolean;
}

const MessageParticipantLabel: React.FC<MessageParticipantCellProps> = ({ message, revert }) => {
  const activeFolder = useSelector((state: RootState) => state.mailbox.activeFolder);
  const user = useSessionUser();

  const recipient = `Do: ${
    message.sender && message.sender.firstName !== null && message.sender.firstName === 'Helpdesk'
      ? 'Helpdesk'
      : getParticipantDisplayName(message.recipient)
  }`;
  const sender = `Od: ${getParticipantDisplayName(message.sender)}`;

  const participantInfo = getTableParticipant(activeFolder, user.user, message);
  let selector = participantInfo === TableMessageParticipant.sender;

  if (revert) {
    selector = !selector;
  }
  return <>{selector ? sender : recipient}</>;
};

export default MessageParticipantLabel;
